"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTACT_LISTS = void 0;
var CONTACT_LISTS = 'contactLists';
exports.CONTACT_LISTS = CONTACT_LISTS;